import i18n from '@/i18n/index'

export default {
  formData: [{
    title: i18n.t('table.product.basicInformation'),
    name: 0,
    createDateItem: [{
      span: 8,
      prop: 'start_date',
      name: 'input',
      type: 'date',
      label: 'Start Date',
      placeholder: i18n.t('placeholder.defaultInput'),
      Object: {
      }
    }, {
      span: 8,
      prop: 'end_date',
      name: 'input',
      type: 'date',
      label: 'End Date',
      placeholder: i18n.t('placeholder.defaultInput'),
      Object: {
      }
    }, {
      span: 8,
      prop: 'cost_price',
      name: 'input',
      type: 'number',
      label: 'Cost Price',
      placeholder: 'Cost Price',
      Object: {
      }
    }, {
      span: 8,
      prop: 'price',
      name: 'input',
      type: 'number',
      label: 'Price',
      placeholder: 'Price',
      Object: {
      }
    }]
  }]
}
